export default __webpack_public_path__ + "static/media/1513.6ec5d0e4.png";